import type { FaireProductEntity } from "../../entity_types/product";

export const p_ar6ja253qt: FaireProductEntity = {
  token: "p_ar6ja253qt",
  type: "product",
  name: "Dorée 18K Gold Non-Tarnish Oval CZ Stud",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/5f05a6eab49f02ecb6d23156f333e632b51e0db5b998718857116b342dab203f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/686053590e242f60ab68644a9c9ae2ec7a4de02698d0085020af6a9c44a16a0d.jpeg",
    "https://cdn.faire.com/fastly/9112338e2fb845d36d9bd350dead981551601835e74e2dd43bb44121e7f121cc.jpeg",
    "https://cdn.faire.com/fastly/5c5b4af7f5b642f6694f95ac58705046f332a2f0b8f08f6bb2b9eaf8a9b747cc.jpeg",
  ],
  priceDollars: 7.82,
  description:
    "18K Gold Non-Tarnish Oval CZ Stud\n18K Gold Plating\nStainless Steel\nMeasurement (L x W inch): 1.09 x 0.96\n\n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:24.950Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
